import { render } from "./BillWerk.vue?vue&type=template&id=9c008510"
import script from "./BillWerk.vue?vue&type=script&lang=js"
export * from "./BillWerk.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__